export default __webpack_public_path__ + "static/media/diamond-assistance.76853fee.gif";